import AxiosServices from './axios-service';
import {endpoints} from './api-end-points';

export class PermitServices {  

  getPermits(body){    
    const res = AxiosServices.post(endpoints.permits.getPermits, body);
    return res;
  }

  addPermit(body){    
    const res = AxiosServices.post(endpoints.permits.addPermit,body);
    return res;
  }

  editPermit(body){    
    const res = AxiosServices.post(endpoints.permits.editPermit,body);
    return res;
  }

  delPermit(body){    
    const res = AxiosServices.post(endpoints.permits.delPermit,body);
    return res;
  }

  buyPermit(body){
    const res = AxiosServices.post(endpoints.permits.buyPermit,body);
    return res; 
  }

  checkPermitLimit(body){
    const res = AxiosServices.post(endpoints.permits.checkPermitLimit,body);
    return res; 
  }

  getUserPermits(body){
    const res = AxiosServices.post(endpoints.permits.getUserPermits,body);
    return res; 
  }

  getTransactionDetail(body){
    const res = AxiosServices.post(endpoints.permits.getTransactionDetail,body);
    return res; 
  }

  editPermitPlate(body){
    const res = AxiosServices.post(endpoints.permits.editPermitPlate,body);
    return res; 
  }

  cancelPermit(body){    
    const res = AxiosServices.post(endpoints.permits.cancelPermit, body);
    return res;
  }

  getPermitsByZone(body){    
    const res = AxiosServices.post(endpoints.permits.getPermitsByZone, body);
    return res;
  }

}
const permitServices = new PermitServices();
export default permitServices;
